export default __webpack_public_path__ + "static/media/multiple-user.b4960ad7.svg";